/**
 * @generated SignedSource<<39c00de168ef29802ebb7b8dfc7318ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeScreen_Query$variables = {
  filterByUsedAtFrom?: string | null;
  filterByUsedToFrom?: string | null;
  id: string;
};
export type discountCodeScreen_Query$data = {
  readonly node: {
    readonly code?: string;
    readonly " $fragmentSpreads": FragmentRefs<"DiscountCodeForm_DiscountCodeFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DiscountCodeUsageTable_DiscountCodeFragment">;
};
export type discountCodeScreen_Query = {
  response: discountCodeScreen_Query$data;
  variables: discountCodeScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByUsedAtFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByUsedToFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "filterByUsedAtFrom",
  "variableName": "filterByUsedAtFrom"
},
v7 = {
  "kind": "Variable",
  "name": "filterByUsedToFrom",
  "variableName": "filterByUsedToFrom"
},
v8 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "discountCodeScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DiscountCodeForm_DiscountCodeFragment"
              }
            ],
            "type": "DiscountCode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DiscountCodeUsageTable_DiscountCodeFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "discountCodeScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "concreteType": "SearchDiscountCodeUsagesResult",
                "kind": "LinkedField",
                "name": "searchUsages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "DiscountCodeUsagesConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountCodeUsagesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DiscountCodeUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "at",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Order",
                                "kind": "LinkedField",
                                "name": "order",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "invoiceData",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "invoiceNumber",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "invoiceFile",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              },
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "CreatedInvoiceData",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "usages(first:10)"
                  },
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "DiscountCodeUsageTable_usages",
                    "kind": "LinkedHandle",
                    "name": "usages"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sumGrossPriceWithDiscounts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sumGrossPriceWithoutDiscounts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "csv",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DiscountCode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6bd8312ab3724f36a75e16a4eb51e6e",
    "id": null,
    "metadata": {},
    "name": "discountCodeScreen_Query",
    "operationKind": "query",
    "text": "query discountCodeScreen_Query(\n  $id: ID!\n  $filterByUsedAtFrom: ZonedDateTIme\n  $filterByUsedToFrom: ZonedDateTIme\n) {\n  node(id: $id) {\n    __typename\n    ... on DiscountCode {\n      code\n      ...DiscountCodeForm_DiscountCodeFragment\n    }\n    id\n  }\n  ...DiscountCodeUsageTable_DiscountCodeFragment_j6l7N\n}\n\nfragment DiscountCodeForm_DiscountCodeFragment on DiscountCode {\n  id\n  code\n}\n\nfragment DiscountCodeUsageTableHeader_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  ...DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment\n  ...DownloadUsageCsvButton_SearchDiscountUsageResultFragment\n}\n\nfragment DiscountCodeUsageTable_DiscountCodeFragment_j6l7N on Query {\n  node(id: $id) {\n    __typename\n    ... on DiscountCode {\n      searchUsages(first: 10, filterByUsedAtFrom: $filterByUsedAtFrom, filterByUsedToFrom: $filterByUsedToFrom) {\n        usages(first: 10) {\n          edges {\n            node {\n              ...DiscountCodeUsageTable_DiscountCodeUsageFragment\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        ...DiscountCodeUsageTableHeader_SearchDiscountUsageResultFragment\n      }\n    }\n    id\n  }\n}\n\nfragment DiscountCodeUsageTable_DiscountCodeUsageFragment on DiscountCodeUsage {\n  ...UsageUsedAtColumn_DiscountCodeUsageFragment\n  ...UsageOrderColumn_DiscountCodeUsageFragment\n  ...UsageIdColumn_DiscountCodeUsageFragment\n  ...UsageInvoiceColumn_DiscountCodeUsageFragment\n}\n\nfragment DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  sumGrossPriceWithDiscounts\n  sumGrossPriceWithoutDiscounts\n}\n\nfragment DownloadUsageCsvButton_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {\n  csv\n}\n\nfragment UsageIdColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  id\n}\n\nfragment UsageInvoiceColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  order {\n    invoiceData {\n      __typename\n      ... on CreatedInvoiceData {\n        invoiceNumber\n        invoiceFile {\n          url\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UsageOrderColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  order {\n    id\n  }\n}\n\nfragment UsageUsedAtColumn_DiscountCodeUsageFragment on DiscountCodeUsage {\n  at\n}\n"
  }
};
})();

(node as any).hash = "6e869769821fd60017fd2c89abb8f9d8";

export default node;
